import http from "../../common/services/httpService";
import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import {PageableModel} from "../../common/models/table";
import {NewShipownerModel, ShipownerModel} from "../models/shipowners";
import {AxiosResponse} from "axios";
import { HttpErrorModel } from "../../common/models/httpError";

export class ShipownerService {
    private static basicUrl = apiUrls.dictionaries.shipowners;

    public static async getAll(sortingAndFilteringParams?: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<ShipownerModel>>> {
        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.basicUrl), sortingAndFilteringParams);
        return await http.get<PageableModel<ShipownerModel>>(url);
    }

    public static async getShipowner(id: string): Promise<AxiosResponse<ShipownerModel>> {
        return await http.get(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async addShipowner(data: NewShipownerModel): Promise<AxiosResponse<HttpErrorModel[]|any>>  {
        return await http.post(Api.getUrl(this.basicUrl), data);
    }

    public static async modifyShipowner(data: NewShipownerModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.basicUrl)}/${id}`, data);
    }

    public static async removeShipowner(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.basicUrl)}/${id}`);
    }
}
